module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 medium-12 large-12"
  }, [_c('div', {
    staticClass: "settings"
  }, [_c('form', {
    staticClass: "pass-form",
    attrs: {
      "id": "change_pass"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.updatePassword($event)
      }
    }
  }, [_c('p', {
    staticClass: "settings__text"
  }, [_vm._v("Сменить пароль")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendCode),
      expression: "sendCode"
    }],
    staticClass: "settings__label"
  }, [_vm._v("\n\t\t\t\t\tКод с смс\n\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "pass-form__field pass-form__field_resp",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkedCode),
      expression: "checkedCode"
    }],
    staticClass: "settings__label"
  }, [_vm._v("\n\t\t\t\t\tНовый пароль\n\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "pass-form__field pass-form__field_resp",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkedCode),
      expression: "checkedCode"
    }],
    staticClass: "settings__label"
  }, [_vm._v("\n\t\t\t\t\tНовый пароль (повтор)\n\t\t\t\t\t"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm_password),
      expression: "confirm_password"
    }],
    staticClass: "pass-form__field pass-form__field_resp",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "pass-form__btn settings__btn basic-blue-btn",
    attrs: {
      "type": "submit",
      "value": "Сменить"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "settings__text"
  }, [_vm._v("Смена аватарки")]), _vm._v(" "), _c('user-avatar', {
    attrs: {
      "data": _vm.user,
      "set-class": 'avatar'
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "file-upload"
  }, [_vm._v("\n\t\t\tЗагрузить файл\n\t\t\t\t"), _c('input', {
    staticClass: "settings__btn file-upload__btn",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.changeAvatar($event)
      }
    }
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9898cc24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Setting.vue
// module id = 638
// module chunks = 0